<template>
  <div class="col-12">
    <b-card>
      <div slot="header">
        <b v-text="$lang.add_ticket_by_operator" />
      </div>
      <ticketFrom
        ref="ticketForm"
        :byOperator="true"
        @cancel="handleBack"
        @submit="save"
        @responseCode="setResponseCode"
      />
    </b-card>
  </div>
</template>

<script>
import ticketFrom from "./../from/ticketFrom";
import { pathOr } from "ramda";

export default {
  components: {
    ticketFrom,
  },
  data() {
    return {
      responseCode: [],
      attachmentId: null,
    };
  },
  inject: ["attachmentTempFinalRepository"],
  methods: {
    async save(payload) {
      this.$refs.ticketForm.loading = true;
      try {
        const url = this.$config.api_url + this.$config.ticket.all_ticket;
        const response = await this.$httpService.post(url, payload);
        const data = pathOr(null, ["data", "data"], response);
        this.attachmentId = pathOr(null, ["ticket_detail_code"], data);
        if (this.attachmentId && this.responseCode.length > 0) {
          await this.finalSave();
        }
        this.$notify.success(response.data.message);
        this.handleBack();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.$refs.ticketForm.loading = false;
      }
    },
    setResponseCode(code) {
      this.responseCode = code;
    },
    async finalSave() {
      try {
        if (this.responseCode.length == 0) return;
        let payload = {
          data: [],
        };
        let resize_avatar = false;
        for (const item of this.responseCode) {
          if (item.type.match("image")) {
            if (this.keyServies == "person") {
              resize_avatar = true;
            }
          }
          payload.data.push({
            code: item.code,
            resize_avatar: resize_avatar,
            attachment_type_id: 22,
            attachment_type_name: "attachment_type_ticket",
          });
        }
        let actionResource = "ticket_detail";
        let actionkey = this.attachmentId;
        const result = await this.attachmentTempFinalRepository.create(
          payload,
          actionResource,
          actionkey
        );
        this.$notify.success(result.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
    handleBack() {
      window.history.length > 1 ? this.$router.go(-1) : window.close();
    },
  },
};
</script>
